<template>
  <div>
    <nav-bar />
    <result :result="result" />
    <b-container>
      <template v-if="step == 1">
        <b-row align-v="center">
          <b-col cols="auto">
            <v-btn class="btn-return" @click="$router.go(-1)">
              <i class="fas fa-arrow-left mr-2 text-twenty"></i> VOLTAR
            </v-btn>
          </b-col>
          <b-col>
            <h1 class="title-pages">RESPONDER FORMULÁRIOS</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h6 class="mb-0 upper-text">Formulário:</h6>
            <b-overlay :show="loading" opacity="0.99">
              <v-select
                label="SELECIONE..."
                item-text="name"
                class="mb-2"
                dense
                hide-details
                outlined
                return-object
                :disabled="loading"
                :items="semiology_forms"
                v-model="selected_form"
                @input="filterResidentsByFormVisibilty"
              />
              <h6 class="mb-0 upper-text">Residentes:</h6>
              <v-text-field
                placeholder="PESQUISAR RESIDENTE"
                class="mb-2"
                v-model="search_resident"
                :disabled="loading"
                dense
                hide-details
                outlined
              />
              <v-data-iterator
                must-sort
                sort-by="name"
                :search="search_resident"
                :items-per-page="5"
                :sort-desc="false"
                :items="residents"
              >
                <template #header v-if="residents.length > 0">
                  <div class="bg-white mb-1 p-1">
                    <b-checkbox
                      :disabled="search_resident.length > 0"
                      :checked="selected_residents.length == residents.length"
                      @change="toggleAll"
                      class="text-fourteen"
                    >
                      {{
                        residents.some((r) => !r.selected)
                          ? "SELECIONAR TODOS"
                          : "DESMARCAR TODOS"
                      }}
                    </b-checkbox>
                  </div>
                </template>
                <template v-slot:default="{ items }">
                  <div class="p-1">
                    <b-checkbox
                      class="text-fifteen bottom-border"
                      v-for="item in items"
                      :key="item.id"
                      :checked="item.selected"
                      @change="toggleResident(item, $event)"
                    >
                      {{ item.name.toUpperCase() }}
                    </b-checkbox>
                  </div>
                </template>
                <template #no-data>
                  <div class="v-clean p-5 text-center">
                    <h6 class="text-center upper-text worksansr">
                      SEM RESULTADOS!
                    </h6>
                  </div>
                </template>
                <template #no-results>
                  <div class="v-clean p-5 text-center">
                    <h6 class="text-center upper-text worksansr">
                      SEM RESULTADOS!
                    </h6>
                  </div>
                </template>
              </v-data-iterator>
            </b-overlay>
          </b-col>
        </b-row>
        <b-row align-h="end">
          <b-col cols="auto">
            <v-btn
              class="btn-acess ml-2"
              @click="nextStep"
              :disabled="
                loading || !selected_form || selected_residents.length == 0
              "
            >
              RESPONDER <i class="fas fa-arrow-right ml-2 text-twenty" />
            </v-btn>
          </b-col>
        </b-row>
      </template>
      <template v-if="step == 2">
        <answer-semiology
          :semiology_form="selected_form"
          :residents="selected_residents"
          @return="evOnReturn"
        />
      </template>
    </b-container>
  </div>
</template>

<script>
import api from "../services/api";
import AnswerSemiology from "../templates/AnswerSemiologies/AnswerSemiology.vue";
import Result from "../templates/AnswerSemiologies/Result.vue";
import NavBar from "../templates/NavBar.vue";

export default {
  name: "AnswerSemiologies",
  components: { NavBar, AnswerSemiology, Result },
  data() {
    return {
      errors: [],
      loading: false,
      step: 1,

      result: undefined,

      semiology_forms: [],
      selected_form: undefined,

      all_residents: [],
      headers: [{ text: "Nome", value: "name" }],
      residents: [],
      search_resident: "",
      selected_residents: [],
    };
  },
  created() {
    this.getFormsByProfile();
    this.getResidents();
  },

  methods: {
    async toggleAll(value) {
      for (let resident of this.residents) resident.selected = value;

      await this.updateSelected();
    },

    async toggleResident(resident, value) {
      resident.selected = value;

      await this.updateSelected();
    },

    async updateSelected() {
      this.selected_residents = [
        ...this.residents.filter((resident) => resident.selected),
      ];
    },

    async getFormsByProfile() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/answer-semiology/forms/by-profile"
        );
        const { error, errors, semiology_forms } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.semiology_forms = semiology_forms;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getResidents() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/active-residents");
        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.all_residents = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async filterResidentsByFormVisibilty() {
      if (this.selected_form.visibility_type_value === "DEGREE_OF_DEPENDENCE") {
        this.residents = this.all_residents
          .filter((resident) =>
            this.selected_form.degrees_of_dependence.includes(
              resident.degree_of_dependence_id
            )
          )
          .filter(
            (resident) =>
              !this.selected_form.ignored_residents.includes(resident.id)
          )
          .map((resident) => ({ selected: false, ...resident }));
      } else if (this.selected_form.visibility_type_value === "PUBLIC") {
        this.residents = this.all_residents
          .filter(
            (resident) =>
              !this.selected_form.ignored_residents.includes(resident.id)
          )
          .map((resident) => ({ selected: false, ...resident }));
      } else if (this.selected_form.visibility_type_value === "MANUAL") {
        this.residents = this.all_residents
          .filter((resident) =>
            this.selected_form.residents.includes(resident.id)
          )
          .map((resident) => ({ selected: false, ...resident }));
      }
    },

    async nextStep() {
      this.step = 2;
    },

    async evOnReturn(result) {
      this.step = 1;
      this.selected_form = undefined;
      this.residents = [];
      this.selected_residents = [];
      this.result = result;
    },
  },
};
</script>

<style>
</style>